import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

interface ISensorLog {
  id: number;
  userName: string;
  timeCreated: string;
  eventText: string;
}

export const sensorLogsKey = (pointId?: string) => ['sensorLogs', pointId];

export const sensorLogsFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/installation-point/${queryKey[1]}/get-log-data`);

const sensorLogsSelect = ({ data }: AxiosResponse<{ data: ISensorLog[] }>) => data?.data || [];

export const useSensorLogsQuery = ({ pointId }: { pointId?: string }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: sensorLogsKey(pointId),
    queryFn: sensorLogsFn,
    enabled: !!pointId,
    select: sensorLogsSelect,
  });
};
